import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { Grid, Paper } from "@mui/material";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { getSmartkioskInitialValues } from "app/pages/customers/dsok/utils/getSmartkioskInitialValues";
import { getLocationsFieldSchema } from "app/pages/customers/dsok/smartkioskFields/SmartkioskLocationFields";
import merge from "lodash/merge";
import { mergeDeep } from "app/utils/objectHelpers";
import { DSOK_CUSTOMER_FIELD_SCHEMA } from "app/pages/customers/dsok/smartkioskFields/SmartkioskCustomerFields";
import SmartkioskLocationsField from "app/pages/customers/dsok/smartkioskFields/SmartkioskLocationFields";
import DsokCustomerDetailLayout from "../components/DsokCustomerDetailLayout";
import DsokCustomerDetailDirtySync from "../components/DsokCustomerDetailDirtySync";
import DsokCustomerDetailSectionRegister from "../components/DsokCustomerDetailSectionRegister";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";

const LOCATIONS_FIELD_NAME = "LOCATIONS_FIELD";

const DsokCustomerLocationsPage = () => {
  const { t } = useTranslation();
  const auth = useJumboAuth();
  const authUser = auth?.getAuthUser?.() || {};
  const userTyp = authUser?.type ?? authUser?.typ ?? 1;
  const isAdmin = userTyp === 1;
  const isPartner = userTyp === 2;

  const { customer } = useDsokCustomerDetail();
  const [expanded, setExpanded] = useState(LOCATIONS_FIELD_NAME);
  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const initialCustomerValues = useMemo(() => {
    if (!customer) {
      return {
        ...DSOK_CUSTOMER_FIELD_SCHEMA,
        locations: {},
      };
    }
    const fullInitial = getSmartkioskInitialValues(customer);
    if (!fullInitial?.customer) {
      const dsokSettings = customer.dsokSettings || {};
      return {
        ...mergeDeep(DSOK_CUSTOMER_FIELD_SCHEMA, dsokSettings.customer || {}),
        locations: merge(
          getLocationsFieldSchema(dsokSettings.customer?.locations),
          dsokSettings.customer?.locations || {}
        ),
      };
    }
    return fullInitial.customer;
  }, [customer]);

  const formInitialValues = { customer: initialCustomerValues };

  return (
    <DsokCustomerDetailLayout
      lastBreadcrumbLabel={t("dsokCustomerDetail.sections.locations.title")}
    >
      <Paper
        variant="outlined"
        sx={{
          bgcolor: "background.paper",
          p: 2,
          borderRadius: 1,
        }}
      >
        <Formik
          initialValues={formInitialValues}
          enableReinitialize
          onSubmit={() => {}}
        >
          <Form>
            <DsokCustomerDetailDirtySync />
            <DsokCustomerDetailSectionRegister
              sectionId="locations"
              getPayload={(values) => values?.customer?.locations ?? null}
            />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SmartkioskLocationsField
                  handleChange={handleChange}
                  expanded={expanded}
                  isAdmin={isAdmin}
                  isPartner={isPartner}
                  isPartnerAdmin={false}
                  customer={customer}
                  hideSectionTitle
                />
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Paper>
    </DsokCustomerDetailLayout>
  );
};

export default DsokCustomerLocationsPage;
